import React from 'react';
import PropTypes from 'prop-types';
import {Dropdown} from '@learningblocks/storybook-components';
import {ZoomContext} from '../../../index';
import './style.scss';

/**
 * ZoomDropdown:
 *  - Component renders the dropdown for PopupZoomImage
 */
export function ZoomDropdown(props) {
  const {state} = React.useContext(ZoomContext);
  return (
    <Dropdown
      placeholder='zoom'
      className='zoom-dropdown'
      options={state.zoomDropdownOptions}
      onChange={props.onChange}
      value={state.zoomValue}
    />
  );
}

ZoomDropdown.propTypes = {
  /**
   * Function to involke when an option changes
   */
  onChange: PropTypes.func.isRequired,
};
